import { render, staticRenderFns } from "./formInsuranceInformation.vue?vue&type=template&id=3050a26a"
import script from "./formInsuranceInformation.vue?vue&type=script&lang=js"
export * from "./formInsuranceInformation.vue?vue&type=script&lang=js"
import style0 from "./formInsuranceInformation.vue?vue&type=style&index=0&id=3050a26a&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3050a26a')) {
      api.createRecord('3050a26a', component.options)
    } else {
      api.reload('3050a26a', component.options)
    }
    module.hot.accept("./formInsuranceInformation.vue?vue&type=template&id=3050a26a", function () {
      api.rerender('3050a26a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fiscalDocuments/mdfe/components/form/steps/formInsuranceInformation.vue"
export default component.exports